// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Utils$OrcaPaymentPage from "./Utils.bs.js";

function mapFieldTypeToInternalFieldName(fieldType) {
  switch (fieldType) {
    case "cardCvc" :
    case "cardExpiry" :
    case "cardNumber" :
      return fieldType;
    default:
      return "";
  }
}

function nextFieldFor(fieldType) {
  switch (fieldType) {
    case "cardExpiry" :
      return "cardCvc";
    case "cardNumber" :
      return "cardExpiry";
    default:
      return;
  }
}

function reshapeCardStateUpdateToChangePayload(fieldType, stateJson) {
  let stateDict = Utils$OrcaPaymentPage.getDictFromJson(stateJson);
  let fieldStatus = Utils$OrcaPaymentPage.getDictFromDict(stateDict, "fieldStatus");
  let empty = Utils$OrcaPaymentPage.getBool(fieldStatus, "empty", true);
  let complete = Utils$OrcaPaymentPage.getBool(fieldStatus, "complete", false);
  let valid;
  switch (fieldType) {
    case "cardCvc" :
      valid = Utils$OrcaPaymentPage.getBool(fieldStatus, "isCvcValid", false);
      break;
    case "cardExpiry" :
      valid = Utils$OrcaPaymentPage.getBool(fieldStatus, "isExpiryValid", false);
      break;
    case "cardNumber" :
      valid = Utils$OrcaPaymentPage.getBool(fieldStatus, "isCardValid", false);
      break;
    default:
      valid = false;
  }
  let brand = Utils$OrcaPaymentPage.getString(stateDict, "cardBrand", "");
  let errorMessage = Utils$OrcaPaymentPage.getString(stateDict, "error", "");
  let changePayload = {};
  changePayload["empty"] = empty;
  changePayload["complete"] = complete;
  changePayload["valid"] = valid;
  changePayload["elementType"] = fieldType;
  if (brand !== "") {
    changePayload["brand"] = brand;
  }
  if (errorMessage !== "") {
    changePayload["error"] = errorMessage;
  }
  return changePayload;
}

export {
  mapFieldTypeToInternalFieldName,
  nextFieldFor,
  reshapeCardStateUpdateToChangePayload,
}
/* Utils-OrcaPaymentPage Not a pure module */
